export const negate = (v: boolean) => !v;

export const foldl =
  <T, U>(fn: F2<U, T, U>, into: U) =>
  (xs: T[]) =>
    xs.reduce(fn, into);

type FoldPredicates = <T>(...ps: Predicate<T>[]) => Predicate<T>;

export const foldPredicates: Record<`with${'And' | 'Or'}`, FoldPredicates> = {
  withAnd:
    (...ps) =>
    (x) =>
      ps.every((p) => p(x)),
  withOr:
    (...ps) =>
    (x) =>
      ps.some((p) => p(x)),
};

// TODO: infer a proper type
export const debounce = (delay: number) => (fn: any) => {
  let timeout: NodeJS.Timeout;

  return (...args: Parameters<typeof fn>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), delay);
  };
};
